<template>
  <div>
    <!-- <img class="mac-img" :src="require(`../../assets/img/bg_mac.png`)" /> -->
    <div class="well preview-push-block">
      <p class="browser-name">
        Chrome, macOS
      </p>
      <div class="preview-push preview-push-chrome-mac">
        <div class="pr-icon-side">
          <div class="pr-icon-wrapper">
            <img :src="require(`../../assets/img/chrome-icon.svg`)" class="pr-icon-chrome" />
          </div>
        </div>
        <div class="pr-message-wrapper">
          <div class="pr-notify-title">
            Hi, it's a title
          </div>
          <div class="pr-notify-site">
            mysite.ru
          </div>
          <div class="pr-notify-message">
            Your message content
          </div>
        </div>
        <div class="pr-icon-side chrome">
          <div class="pr-icon-wrapper pr-icon-wrapper-left">
            <img id="preview-push-chrome-mac" :src="url" class="pr-icon" />
          </div>
        </div>
        <div class="pr-icon-side text-center">
          <div class="pr-system-btn">Close</div>
          <div class="pr-system-btn">Settings</div>
        </div>
      </div>
      <p class="browser-name">
        Firefox, Windows
      </p>
      <div class="preview-push preview-push-firefox">
        <span class="close-notify">×</span>
        <div class="preview-push-flex-wrap">
          <div class="pr-icon-side">
            <div class="pr-icon-wrapper">
              <img id="preview-push-firefox" :src="url" class="pr-icon" />
            </div>
          </div>
          <div class="pr-message-wrapper">
            <div class="pr-notify-title">
              Hi, it's a title
            </div>
            <div class="pr-notify-message">
              Your message content
            </div>
            <div class="pr-notify-site-wrap">
              <div class="pr-notify-site">
                mysite.ru
              </div>
            </div>
            <img
              class="cog-icon"
              width="14"
              height="14"
              src="data:image/svg+xml;utf8;base64,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"
            />
          </div>
        </div>
      </div>

      <p class="browser-name">
        Chrome, Windows
      </p>
      <div class="preview-push preview-push-chrome-win">
        <span class="close-notify">×</span>
        <div class="pr-notify-big-image" id="chrome-big-image">
          <!--<img src="/img/push/prompt-help-text-ru.png" />-->
        </div>
        <div class="preview-push-flex-wrap">
          <div class="pr-icon-side">
            <div class="pr-icon-wrapper">
              <img id="preview-push-chrome-win" :src="url" class="pr-icon" />
            </div>
          </div>
          <div class="pr-message-wrapper">
            <div class="pr-notify-title">
              Hi, it's a title
            </div>
            <div class="pr-notify-message">
              Your message content
            </div>
            <div class="pr-notify-site-wrap">
              Google Chrome •
              <div class="pr-notify-site">
                mysite.ru
              </div>
            </div>
            <img
              class="cog-icon"
              width="14"
              height="14"
              src="data:image/svg+xml;utf8;base64,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"
            />
          </div>
        </div>

        <div class="preview-push-flex-wrap pr-buttons-wrapper">
          <div class="pr-notify-btn-1"></div>
          <div class="pr-notify-btn-2"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {
    url: {
      type: String,
      default() {
        return ''
      },
    },
  },
}
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.text-center {
  text-align: center;
}
.width_limit img,
img.img {
  max-width: 100%;
}
.cog-icon {
  bottom: 10px;
}
.close-notify,
.cog-icon {
  right: 10px;
  position: absolute;
}

.pr-icon-side {
  display: table-cell;
  vertical-align: top;
  width: 82px;
}
.pr-icon-wrapper {
  display: table-cell;
  vertical-align: middle;
  background-color: #fff;
  width: 82px;
  height: 82px;
}
.pr-icon-wrapper,
.pr-notify-big-image {
  text-align: center;
}
.preview-push .pr-icon {
  max-width: 82px;
  max-height: 82px;
}
.pr-message-wrapper {
  display: table-cell;
  vertical-align: top;
  padding: 10px 15px;
  position: relative;
  width: 278px;
}
.preview-push-chrome-win .pr-notify-message,
.preview-push-chrome-win .pr-notify-title {
  font-size: 15px;
}
.pr-notify-title {
  font-size: 13.2px;
  margin-bottom: 5px;
  max-height: 38px;
}
.pr-notify-message,
.pr-notify-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -moz-box;
  display: -webkit-box;
  -moz-box-orient: horizontal;
}
.pr-notify-message,
.pr-notify-title {
  display: box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  box-orient: vertical;
}
.pr-notify-message {
  margin-bottom: 5px;
  display: box;
  -webkit-box-orient: vertical;
  box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  max-height: 52px;
}
.pr-notify-site {
  color: #7f7f7f;
}
.pr-notify-message,
.pr-notify-site {
  font-size: 12px;
}
.preview-push {
  margin-left: auto;
  margin-right: auto;
  width: 360px;
  overflow: hidden;
  position: relative;
  background: #fff;
  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  font-family: 'Segoe UI', 'Lucida Sans Unicode', sans-serif;
}
.preview-push-block {
  background: url('../../assets/img/bg_mac.png');
  width: 406px;
  background-size: cover;
  background-repeat: no-repeat;
  border: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.3);
  img {
    vertical-align: middle;
  }
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.3);
  .close-notify {
    top: 5px;
    font-weight: 700;
    font-size: 17px;
    color: #777;
  }
  .close-notify,
  .cog-icon {
    right: 10px;
    position: absolute;
  }
  .preview-push {
    margin-bottom: 15px;
  }
  .preview-push-chrome-win {
    background: #404445;
    padding: 22px 20px;
    .close-notify,
    .preview-push-chrome-win .cog-icon {
      display: none !important;
    }
    .pr-notify-big-image {
      margin: -24px -16px 24px;
    }
    .pr-icon-wrapper,
    .pr-notify-big-image {
      text-align: center;
    }
    .preview-push-flex-wrap {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      -ms-flex-direction: row;
      flex-direction: row;
      -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
    }
    .pr-icon-side {
      max-width: 42px;
      -webkit-box-flex: 0;
      -ms-flex: 0 0 42px;
      flex: 0 0 42px;
      display: block;
      width: auto;
      margin-right: 18px;
    }
    .pr-icon-wrapper {
      width: 42px;
      height: 42px;
    }
    .pr-icon {
      max-width: 42px;
      max-height: 42px;
    }
    .pr-message-wrapper {
      padding: 0;
      width: auto;
    }
    .pr-notify-title {
      color: #fff;
      margin: -6px 0 3px;
      line-height: 17px;
      font-weight: 500;
    }
    .pr-notify-message {
      color: #b5b5b5;
      line-height: 19px;
      max-height: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -moz-box;
      display: -webkit-box;
      display: box;
      -moz-box-orient: horizontal;
      -webkit-box-orient: vertical;
      box-orient: vertical;
      -webkit-line-clamp: 4;
      line-clamp: 4;
      max-width: 264px;
      margin-bottom: 5px;
    }
    .pr-notify-message,
    .preview-push-chrome-win .pr-notify-title {
      font-size: 15px;
    }
    .pr-notify-site-wrap {
      white-space: nowrap;
      color: #b5b5b5;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
    }
    .pr-notify-site {
      display: inline;
      color: #b5b5b5;
    }
    .cog-icon {
      opacity: 0.6;
    }
    .pr-buttons-wrapper {
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: flex-end;
    }
    .preview-push-flex-wrap {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      -ms-flex-direction: row;
      flex-direction: row;
      -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
    }
  }

  .preview-push-firefox {
    border: 1px solid #d1d1d1;
    -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    .close-notify {
      font-weight: 400;
      font-size: 20px;
      top: -1px;
      right: 8px;
    }
    .pr-icon-side {
      padding-top: 20px;
      vertical-align: middle;
      width: 94px;
    }
    .pr-icon-wrapper {
      background-color: transparent;
    }
    .pr-icon {
      max-width: 80px;
      max-height: 80px;
      margin: 7px;
    }
    .pr-message-wrapper {
      padding: 5px 25px 10px 0;
    }
    .pr-notify-title {
      margin-bottom: 5px;
      color: #191919;
    }
    .pr-notify-title {
      font-size: 12px;
      font-weight: 700;
      margin-left: -87px;
      display: box;
      -webkit-box-orient: vertical;
      box-orient: vertical;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      max-height: 18px;
    }
    .pr-notify-title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -moz-box;
      display: -webkit-box;
      -moz-box-orient: horizontal;
    }
    .pr-notify-message,
    .pr-notify-title {
      margin-bottom: 5px;
      color: #191919;
    }
    .pr-notify-message {
      display: -webkit-box;
      display: box;
      -webkit-box-orient: vertical;
      box-orient: vertical;
      -webkit-line-clamp: 5;
      line-clamp: 5;
      min-height: 59px;
      max-height: 88px;
    }
    .pr-notify-message {
      display: -moz-box;
      -moz-box-orient: horizontal;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .pr-notify-site {
      font-size: 10px;
      color: #6d6d6d;
    }
  }

  .preview-push-chrome-mac {
    height: 60px;
    width: 345px;
    -webkit-box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    background-color: rgba(255, 255, 255, 0.8);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 6px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-family: -apple-system, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: subpixel-antialiased;
    .pr-icon-side {
      width: 42px;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
    }
    .pr-icon-wrapper {
      height: 32px;
      background: 0 0;
      width: 40px;
      text-align: right;
    }
    .pr-icon-chrome {
      max-width: 30px;
      max-height: 28px;
    }
    .pr-message-wrapper {
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      max-width: 185px;
      padding: 7px 8px;
    }
    .pr-notify-title {
      margin-bottom: 3px;
      font-weight: 600;
    }
    .pr-notify-title {
      font-size: 12px;
      line-height: 1.2;
      display: -webkit-box;
      display: box;
      -webkit-box-orient: vertical;
      box-orient: vertical;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      max-height: 14px;
      color: rgba(0, 0, 0, 0.8);
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .pr-notify-site {
      font-size: 11px;
      line-height: 1.2;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -moz-box;
      display: -webkit-box;
      display: box;
      -moz-box-orient: horizontal;
      -webkit-box-orient: vertical;
      box-orient: vertical;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      max-height: 13px;
      color: rgba(0, 0, 0, 0.8);
      margin-bottom: 3px;
      font-weight: 600;
    }
    .pr-notify-message {
      font-size: 11px;
      line-height: 1.2;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -moz-box;
      display: -webkit-box;
      display: box;
      -moz-box-orient: horizontal;
      -webkit-box-orient: vertical;
      box-orient: vertical;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      max-height: 13px;
      color: rgba(0, 0, 0, 0.8);
      margin-bottom: 0;
    }
    .pr-icon-side {
      display: flex;
      &.chrome {
        width: 52px;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 52px;
        flex: 0 0 52px;
      }
    }
    .pr-icon-wrapper-left {
      text-align: left;
      height: auto;
    }
    .pr-icon-wrapper {
      background: 0 0;
      width: 40px;
    }
    .pr-icon-side.chrome img {
      border-radius: 2px;
    }
    .pr-icon {
      max-width: 42px;
      max-height: 42px;
    }
    .pr-icon-side.text-center {
      border-left: 1px solid #d4ced0;
      width: auto;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
    }
    .pr-icon-side {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
    }
    .pr-system-btn:first-child {
      border-bottom: 1px solid #d4ced0;
    }
    .pr-system-btn {
      font-size: 12px;
      font-weight: 600;
      padding: 6px 8px;
      width: 100%;
      color: rgba(0, 0, 0, 0.6);
    }
    .pr-system-btn {
      font-size: 12px;
      font-weight: 600;
      padding: 6px 8px;
      width: 100%;
      color: rgba(0, 0, 0, 0.6);
    }
  }
}
.well {
  border-radius: 6px;
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
}
.browser-name {
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  width: 360px;
  margin-bottom: 6px;
  color: rgba(0, 0, 0, 0.75);
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.2);
  &p {
    margin: 0 0 10.5px;
  }
}
.mac-img {
  width: 406px;
}
</style>
